import React from 'react';
import { connect } from 'react-redux';
import VisibilitySensor from 'react-visibility-sensor/visibility-sensor'
import {
  actions, apiActions, deleteConfirmationActions, optionsMenuActions, readingActions,
  signinActions
} from '../../../actions';
import { isLogged } from '../helpers';
import {
  CommentsListItemBody,
  CommentsListItemBodyWraper,
  CommentsListItemCommentType,
  CommentsListItemContainer,
  CommentsListItemFooter,
  CommentsListItemHeader,
  UserAvatar
} from '../../design/CommentsListItem';
import ReplyForm from './ReplyForm';
import UpdateForm from './UpdateForm';
import OptionsMenu from './OptionsMenu';
import DeleteConfirmation from './DeleteConfirmation';
import Icon from '../../design/socialControls/Icon';

class ListItem extends React.Component {
  constructor(props) {
    super(props);
    this.toggleOptionsMenu = this.toggleOptionsMenu.bind(this);
    this.handleReplyClick = this.handleReplyClick.bind(this);
    this.sendReaction = this.sendReaction.bind(this);
  }

  handleReplyClick(event) {
    event.preventDefault();
    if (isLogged()) {
      this.props.openReplyForm(this.props.id, this.props.comment_type);
    } else {
      this.props.openSigninModalWithCallback(
        this.props.openReplyForm,
        'openReplyForm',
        [this.props.id, this.props.comment_type]
      );
    }
  }

  toggleOptionsMenu() {
    this.props.optionsMenuOpened ? this.props.closeOptionsMenu() : this.props.openOptionsMenu(this.props.optionsMenuSetup);
  }

  sendReaction(event) {
    event.preventDefault();
    const propsWithAction = {
      ...this.props,
      ...{ action: (event.target.parentElement.classList.contains('up') ? (this.props.liked ? 'unlike' : 'like') : (this.props.disliked ? 'undislike' : 'dislike')),
        parent_id: this.props.id
      }
    };
    if (isLogged()) {
      this.props.popReactionSend(propsWithAction);
    } else {
      this.props.openSigninModalWithCallback(
        this.props.popReactionSend,
        'popReactionSend',
        [{ ...propsWithAction, per_page: this.props.current_episode_comments.length, page_number: 1 }]
      );
    }
  }

  render() {
    return (
      <CommentsListItemContainer className={this.props.skin}>
        { this.props.withSensor && <VisibilitySensor onChange={this.props.loadMoreComments} partialVisibility /> }
        <UserAvatar img={this.props.avatar_url} />
        <CommentsListItemBodyWraper>

          <CommentsListItemHeader
            author={this.props.author}
            deleteConfirmationOpened={this.props.deleteConfirmationOpened}
            optionsMenuOpened={this.props.optionsMenuOpened}
            owned={this.props.owned}
            time={prettyDateTime(this.props.created_at)}
            toggleMenu={this.toggleOptionsMenu}
            optionsMenu={<OptionsMenu body={this.props.body} />}
            deleteConfirmation={<DeleteConfirmation />}
          />

          <CommentsListItemCommentType
            parentType={this.props.parent_type}
            displayType={this.props.display_type}
            clickAction={this.props.openPoppinOnPage}
          />

          <CommentsListItemBody
            body={this.props.body}
            editable={this.props.update_form_open}
            UpdateForm={<UpdateForm />}
          />

          <CommentsListItemFooter
            canReply={this.props.can_reply}
            replyClick={this.handleReplyClick}
            replyTranslation={I18n.t('components.webreader_comments_list_item.reply')}
            likedCount={this.props.likes_count}
            dislikedCount={this.props.dislikes_count}
            like={
              <Icon
                img={`/images/webreader/ic-thumb-u${this.props.liked ? '-fill' : ''}.svg`}
                onClick={this.sendReaction}
                className="up"
              />
            }
            dislike={
              <Icon
                img={`/images/webreader/ic-thumb-d${this.props.disliked ? '-fill' : ''}.svg`}
                onClick={this.sendReaction}
                className="down"
              />
            }
          />

          { this.props.reply_form_open && <ReplyForm opened={this.props.reply_form_open} /> }
          { this.props.children }
        </CommentsListItemBodyWraper>
      </CommentsListItemContainer>
    );
  }
}

const mapState = (state, ownProps) => {
  const owned = state.currentUser.user && state.currentUser.user.id === ownProps.userId;
  const parentType = (ownProps.can_reply ? ownProps.comment_type : 'PopCommentReply');
  const translatedType = I18n.t(`components.webreader_comments_list_item.translated_type.${parentType}`);
  return {
    current_user: state.current_user,
    episode_id: state.currentEpisode.id,
    current_episode_comments: state.current_episode_comments,
    owned,
    display_type: parentType === 'TsukkomiComment' ? translatedType + ownProps.page_number : translatedType,
    reply_form_open: (
      ownProps.can_reply &&
      state.reply_form.parent_id === ownProps.id &&
      state.reply_form.parent_type === ownProps.comment_type
    ),
    optionsMenuOpened: (
      owned &&
      state.optionsMenu.parentId === ownProps.id &&
      state.optionsMenu.parentType === parentType
    ),
    deleteConfirmationOpened: (
      state.deleteConfirmation.parentId === ownProps.id &&
      state.deleteConfirmation.parentType === parentType
    ),
    update_form_open: (
      owned &&
      state.update_form.parent_id === ownProps.id &&
      state.update_form.parent_type === parentType
    ),
    parent_type: parentType,
    optionsMenuSetup: {
      parentId: ownProps.id,
      parentType,
      commentedId: ownProps.commented_id,
      commentedType: ownProps.commented_type
    },
    action: ''
  };
};

const mapDispatch = (dispatch, ownProps) => ({
  closeOptionsMenu: () => {
    dispatch(optionsMenuActions.closeOptionsMenu());
  },
  openOptionsMenu: (optionsMenuSetup) => {
    dispatch(optionsMenuActions.openOptionsMenu(optionsMenuSetup));
  },
  openReplyForm: (parentId, parentType) => {
    dispatch(actions.closeUpdateForm());
    dispatch(deleteConfirmationActions.deleteConfirmationClose());
    dispatch(actions.openReplyForm(parentId, parentType));
  },
  openPoppinOnPage: () => {
    dispatch(readingActions.openPoppinOnPage(ownProps.id, ownProps.page_number));
  },
  openSigninModalWithCallback: (callback, callbackType, callbackArgs) => {
    dispatch(signinActions.openModalWithCallback(callback, callbackType, callbackArgs));
  },
  popReactionSend: (props) => {
    dispatch(apiActions.popReactionSend(props));
  }
});

export default connect(mapState, mapDispatch)(ListItem);
